import { render } from "./TasksProject.vue?vue&type=template&id=596358d7"
import script from "./TasksProject.vue?vue&type=script&lang=js"
export * from "./TasksProject.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__